import React from 'react';
import { GatewayPagamento } from '../../types/financeiro';
import { CreditCard, Globe, ShieldCheck } from 'lucide-react';

interface FinanceiroGatewaysSectionProps {
  gateways: GatewayPagamento[];
  loading: boolean;
}

export function FinanceiroGatewaysSection({ gateways, loading }: FinanceiroGatewaysSectionProps) {
  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-2xs flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-purple-50 text-purple-600 rounded-xl">
            <CreditCard className="w-5 h-5" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-slate-900">Gateways de Pagamento Configurados</h3>
            <p className="text-xs text-slate-500">
              Integrações ativas para cobranças via PIX, Boleto e Cartão de Crédito.
            </p>
          </div>
        </div>
        <span className="text-xs font-bold text-slate-700 bg-slate-100 px-2.5 py-1 rounded-xl">
          {gateways.length} Gateway(s)
        </span>
      </div>

      <div className="bg-white shadow-xs rounded-2xl overflow-hidden border border-slate-200">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-slate-200 text-xs">
            <thead className="bg-slate-50">
              <tr>
                <th className="px-5 py-3 text-left font-bold text-slate-600 uppercase tracking-wider">ID</th>
                <th className="px-5 py-3 text-left font-bold text-slate-600 uppercase tracking-wider">Nome do Gateway</th>
                <th className="px-5 py-3 text-left font-bold text-slate-600 uppercase tracking-wider">Webhook URL</th>
                <th className="px-5 py-3 text-left font-bold text-slate-600 uppercase tracking-wider">Status Integração</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-100">
              {loading ? (
                <tr>
                  <td colSpan={4} className="px-6 py-8 text-center text-slate-500">
                    Carregando gateways...
                  </td>
                </tr>
              ) : gateways.length === 0 ? (
                <tr>
                  <td colSpan={4} className="px-6 py-8 text-center text-slate-500">
                    Nenhum gateway de pagamento cadastrado no momento.
                  </td>
                </tr>
              ) : (
                gateways.map((g) => (
                  <tr key={`gateway-${g.id}`} className="hover:bg-slate-50/70 transition-colors">
                    <td className="px-5 py-3.5 font-bold text-slate-900">#{g.id}</td>
                    <td className="px-5 py-3.5 font-bold text-slate-800">
                      <div className="flex items-center gap-2">
                        <CreditCard className="w-4 h-4 text-slate-400" />
                        <span>{g.nome}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3.5 text-slate-500 font-mono text-[11px] max-w-sm truncate">
                      {g.webhook_url || 'Não configurado'}
                    </td>
                    <td className="px-5 py-3.5">
                      <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
                        <ShieldCheck className="w-3 h-3 text-emerald-600" />
                        Ativo
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
